//angular imports
import {
  ChangeDetectionStrategy,
  Component,
  signal,
  WritableSignal,
} from "@angular/core";

//local imports
import { PresenterType } from "@app/shared";
import { UnhandledErrorMessage } from "./unhandled-error-message.model";

@PresenterType({
  model: UnhandledErrorMessage,
})
@Component({
  selector: "unhandled-error-message",
  standalone: false,
  templateUrl: "./unhandled-error-message.component.html",
  styleUrl: "./unhandled-error-message.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UnhandledErrorMessageComponent {
  public data: WritableSignal<UnhandledErrorMessage>;

  constructor() {
    this.data = signal<UnhandledErrorMessage>(null);
  }
}
